// React
import React from 'react';
// Material-UI
import { IconButton } from '@material-ui/core';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import ClearIcon from "@material-ui/icons/Clear";
import esLocale from "date-fns/locale/es";
import DateFnsUtils from "@date-io/date-fns";
// Otras libs

// Componentes

// Funciones

// Hooks


/**
 * Especifica la función a ser ejecutada al cambiar de fecha
 * @callback OnChange
 * @param {Date} fecha - Nueva fecha
 * @returns {void}
 */

/**
 *
 * @typedef {Object} Props
 * @property {string} name Nombre de elemento
 * @property {string} label Etiqueta
 * @property {Date | null} value Fecha
 * @property {boolean} clearable Si componente permite eliminar fecha
 * @property {Date | undefined} [minDate] Fecha mínima
 * @property {Date | undefined} [maxDate] Fecha maxima
 * @property {string} format Formato
 * @property {boolean} disabled Disabled
 * @property {boolean} required Required
 * @property {Array<"year" | "date" | "month">} views Array of views to show
 * @property {boolean} readOnly Si solo es posible seleccionar la fecha desde el selector
 * @property {boolean} disableInput Indica si se deshabilita el input de texto del selector de fecha
 * @property {string} [helperText] Texto de ayuda bajo el campo
 * @property {OnChange} onChange Evento al cambiar de fecha
 */

/**
 * Lista
 * @param {Props} props
 * @param {ChildrenFn} props.children
 * @returns
 */
export const SelectorFecha = ({ 
    name = '',
    label = '',
    value = null, 
    clearable = false,
    minDate = undefined,
    maxDate = undefined,
    format = 'dd/MM/yyyy',
    disabled = false,
    required = false,
    views = undefined,
    readOnly = false,
    disableInput = false,
    helperText = undefined,
    onChange = (fecha) => {},
 }) => {
    // Idioma

    // Estados

    // Vista
    return (
        <MuiPickersUtilsProvider utils={DateFnsUtils} locale={esLocale}>
            <KeyboardDatePicker
                name={name}
                label={label}
                inputVariant="outlined"
                format={format}
                fullWidth
                size="small"
                value={value}
                onChange={(d, v) => onChange(d)}
                clearable={clearable}
                minDate={minDate}
                maxDate={maxDate}
                disabled={disabled}
                required={required}
                helperText={helperText}
                views={views}
                onKeyDown={(e) => {
                    if (disableInput) {
                        e.preventDefault()
                    }
                }}
                InputProps={clearable 
                    ? {
                        endAdornment: (
                            <IconButton size="small" onClick={() => onChange(null)}>
                                <ClearIcon />
                            </IconButton>
                        ),
                    } : { readOnly: readOnly, style: { fontSize: '14px' } }
                }
                InputAdornmentProps={clearable
                    ? { position: "start" }
                    : undefined
                }
                KeyboardButtonProps={{ style: { padding: '0px' } }}
            />
        </MuiPickersUtilsProvider>
    );
};
